/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { StyledModal } from 'sarsaparilla';

const propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    title: PropTypes.string,
    children: PropTypes.element,
};

if (process.env.NODE_ENV !== 'test') {
    Modal.setAppElement('#recApp');
}

export default function InfoModal({ isOpen, closeModal, title, children }) {
    return (
        <StyledModal
            size="md"
            isOpen={isOpen}
            heading={title}
            onRequestClose={closeModal}
        >
            {children}
        </StyledModal>
    );
}

InfoModal.propTypes = propTypes;
